const initState = { // all selections
    isOpen: false,
    tab: "all_indices",
    qtype: '1',
    stype:"chronological",
    collections: [], //ids
    authors: [], //ids
    volumes: [], //col-vol
    years: [],
    chapters: [],
    months:[],
    languages: [],
    periodicalIndexes: [],
    mtmIndexes: [],
    arabicIndexes: [],
    thisWeekWithHuzoorYears: [],
    thisWeekWithHuzoorMonths: [],
    thisWeekWithHuzoorLanguages: ['en'],
    beaconOfGuidanceYears: [],
    beaconOfGuidanceMonths: [],
    beaconOfGuidanceLanguages: ['en']
}


const filtersReducer = (state=initState, action) => {
    switch (action.type) {
        case 'TOGGLE_MODAL': {
            state = {
                ...state,
                isOpen: action.value
            }
            break;
        }
        case 'ADD_CHAPTER': {
            console.log('added..', action.chapter)
            state = {
                ...state,
                chapters: [...state.chapters, action.chapter]
            }
            break;
        }
        case 'REMOVE_CHAPTER': {
            console.log('removed..', action.chapter)
            state = {
                ...state,
                chapters: state.chapters.filter(c => c !== action.chapter)
            }
            break;
        }
        case 'ADD_COLLECTION': {
            state = {
                ...state,
                collections: [...state.collections, action.collection]
            }
            break;
        }
        case 'REMOVE_COLLECTION': {
            state = {
                ...state,
                collections: state.collections.filter(coll => coll !== action.collection)
            }
            break;
        }
        case 'ADD_AUTHOR': {
            state = {
                ...state,
                authors: [...state.authors, action.author]
            }
            break;
        }
        case 'REMOVE_AUTHOR': {
            state = {
                ...state,
                authors: state.authors.filter(a => a !== action.author)
            }
            break;
        }
        case 'ADD_VOLUME': {
            state = {
                ...state,
                volumes: [...state.volumes, action.vno]
            }

            break;
        }
        case 'REMOVE_VOLUME': {
            state = {
                ...state,
                volumes: state.volumes.filter(vno => vno !== action.vno)
            }
            break;
        }
        case 'ADD_VOLUMES': {
            state = {
                ...state,
                volumes: [...state.volumes, ...action.volumes]
            }
            break;
        }
        case 'ADD_AUTHORS': {
            state = {
                ...state,
                authors: [...state.authors, ...action.authors]
            }
            break;
        }
        case 'ADD_COLLECTIONS': {
            state = {
                ...state,
                collections: [...state.collections, ...action.collections]
            }
            break;
        }
        case 'REMOVE_COLLECTIONS': {
            state = {
                ...state,
                collections: []
            }
            break;
        }
        case 'REMOVE_AUTHORS': {
            state = {
                ...state,
                authors: []
            }
            break;
        }

        case 'REPLACE_ALL': {
            state = {
                ...state,
                collections: action.data.collections ? action.data.collections : state.collections,
                authors: action.data.authors ? action.data.authors : state.authors,
                volumes: action.data.volumes ? action.data.volumes : state.volumes,
                years: action.data.years ? action.data.years : state.years,
                months: action.data.months ? action.data.months : state.months,
                languages: action.data.languages ? action.data.languages : state.languages,
                qtype: action.data.qtype ? action.data.qtype : state.qtype,
                stype: action.data.stype ? action.data.stype : state.stype,
                periodicalIndexes: action.data.periodicalIndexes ? action.data.periodicalIndexes : state.periodicalIndexes,
                mtmIndexes: action.data.mtmIndexes ? action.data.mtmIndexes : state.mtmIndexes,
                arabicIndexes: action.data.arabicIndexes ? action.data.arabicIndexes : state.arabicIndexes,
                thisWeekWithHuzoorYears: action.data.thisWeekWithHuzoorYears ? action.data.thisWeekWithHuzoorYears : state.thisWeekWithHuzoorYears,
                thisWeekWithHuzoorMonths: action.data.thisWeekWithHuzoorMonths ? action.data.thisWeekWithHuzoorMonths : state.thisWeekWithHuzoorMonths,
                thisWeekWithHuzoorLanguages: action.data.thisWeekWithHuzoorLanguages ? action.data.thisWeekWithHuzoorLanguages : state.thisWeekWithHuzoorLanguages,
                beaconOfGuidanceYears: action.data.beaconOfGuidanceYears ? action.data.beaconOfGuidanceYears : state.beaconOfGuidanceYears,
                beaconOfGuidanceMonths: action.data.beaconOfGuidanceMonths ? action.data.beaconOfGuidanceMonths : state.beaconOfGuidanceMonths,
                beaconOfGuidanceLanguages: action.data.beaconOfGuidanceLanguages ? action.data.beaconOfGuidanceLanguages : state.beaconOfGuidanceLanguages

            }
            break;
        }
        case 'CHANGE_TAB': {
            state = {
                ...state,
                tab: action.tab,
                periodicalIndexes: [],
                mtmIndexes: [],
                arabicIndexes: [],
                years: [],
                months: [],
                languages: ['thisWeekWithHuzoor', 'beaconOfGuidance'].includes(action.tab) ? ['en'] : [],
                thisWeekWithHuzoorYears: [],
                thisWeekWithHuzoorMonths: [],
                thisWeekWithHuzoorLanguages: ['en'],
                beaconOfGuidanceYears: [],
                beaconOfGuidanceMonths: [],
                beaconOfGuidanceLanguages: ['en']
            }
            break;
        }
        // ror
        case 'ADD_YEAR': {
            state = {
                ...state,
                years: [...state.years, action.year]
            }
            break;
        }

        case 'REMOVE_YEAR': {
            state = {
                ...state,
                years: state.years.filter(y => y !== action.year)
            }
            break;
        }

        case 'ADD_YEARS': {
            state = {
                ...state,
                years: [...action.years]
            }
            break;
        }
        case 'REMOVE_YEARS': {
            state = {
                ...state,
                years: []
            }
            break;
        }
        case 'CHANGE_QTYPE': {
            state = {
                ...state,
                qtype: action.value
            }
            break;
        }
        case 'CHANGE_SORTORDER': {
            state = {
                ...state,
                stype: action.value
            }
            break;
        }
        case 'ADD_MONTH': {
            state = {
                ...state,
                months: [...state.months, action.month]
            }
            break;
        }
        case 'REMOVE_MONTH': {
            state = {
                ...state,
                months: state.months.filter(y => y !== action.month)
            }
            break;
        }
        case 'ADD_LANGUAGE': {
            state = {
                ...state,
                languages: state.languages.includes(action.language)
                    ? state.languages
                    : [...state.languages, action.language]
            }
            break;
        }
        case 'REMOVE_LANGUAGE': {
            state = {
                ...state,
                languages: state.languages.filter(language => language !== action.language)
            }
            break;
        }
        case 'ADD_PERIODICAL_INDEX': {
            state = {
                ...state,
                periodicalIndexes: [...state.periodicalIndexes, action.index]
            }
            break;
        }
        case 'REMOVE_PERIODICAL_INDEX': {
            state = {
                ...state,
                periodicalIndexes: state.periodicalIndexes.filter(idx => idx !== action.index)
            }
            break;
        }
        case 'ADD_PERIODICAL_INDEXES': {
            state = {
                ...state,
                periodicalIndexes: [...action.indexes]
            }
            break;
        }
        case 'REMOVE_PERIODICAL_INDEXES': {
            state = {
                ...state,
                periodicalIndexes: []
            }
            break;
        }
        case 'ADD_MTM_INDEX': {
            state = {
                ...state,
                mtmIndexes: state.mtmIndexes.includes(action.index)
                    ? state.mtmIndexes
                    : [...state.mtmIndexes, action.index]
            }
            break;
        }
        case 'REMOVE_MTM_INDEX': {
            state = {
                ...state,
                mtmIndexes: state.mtmIndexes.filter(idx => idx !== action.index)
            }
            break;
        }
        case 'ADD_MTM_INDEXES': {
            state = {
                ...state,
                mtmIndexes: [...action.indexes]
            }
            break;
        }
        case 'REMOVE_MTM_INDEXES': {
            state = {
                ...state,
                mtmIndexes: []
            }
            break;
        }
        case 'ADD_ARABIC_INDEX': {
            state = {
                ...state,
                arabicIndexes: state.arabicIndexes.includes(action.index)
                    ? state.arabicIndexes
                    : [...state.arabicIndexes, action.index]
            }
            break;
        }
        case 'REMOVE_ARABIC_INDEX': {
            state = {
                ...state,
                arabicIndexes: state.arabicIndexes.filter(idx => idx !== action.index)
            }
            break;
        }
        case 'ADD_ARABIC_INDEXES': {
            state = {
                ...state,
                arabicIndexes: [...action.indexes]
            }
            break;
        }
        case 'REMOVE_ARABIC_INDEXES': {
            state = {
                ...state,
                arabicIndexes: []
            }
            break;
        }
        case 'ADD_FILTER_VALUE': {
            if (!Array.isArray(state[action.field])) break;
            state = {
                ...state,
                [action.field]: state[action.field].includes(action.value)
                    ? state[action.field]
                    : [...state[action.field], action.value]
            }
            break;
        }
        case 'REMOVE_FILTER_VALUE': {
            if (!Array.isArray(state[action.field])) break;
            state = {
                ...state,
                [action.field]: state[action.field].filter(value => value !== action.value)
            }
            break;
        }
        case 'REPLACE_FILTER_VALUES': {
            if (!Array.isArray(state[action.field])) break;
            state = {
                ...state,
                [action.field]: [...action.values]
            }
            break;
        }
        case 'CLEAR_FILTER_VALUES': {
            if (!Array.isArray(state[action.field])) break;
            state = {
                ...state,
                [action.field]: []
            }
            break;
        }

    }
    return state
}


export default filtersReducer;
